export default {
  OFF: "off",
  DESKTOP: "desktop",
  TSP100TSP650: "tsp100tsp650",
};
